import axios from "axios";

class SportRepository {
  get() {
    return axios.get(`${BASE_URL}/sports`).then((response) => {
      return response.data;
    });
  }
}

export default new SportRepository();



// WEBPACK FOOTER //
// ./src/data/sport.repository.js